import axios from 'axios'

export default {
  fetchTopics: async ({ commit }) => {
    const response = await axios.get('api/notas/temas/')
    const noteDetail = response.data
    commit('SET_TOPICS', noteDetail)
  }
}
